import React from 'react';
import CustomHeroImage from './../components/CustomHeroImage/CustomHeroImage';
import Form from './../components/Form/Form';

function Contact() {
  return (
    <div>
       <CustomHeroImage 
      heading="CONTACT"
      text="Let's have a chat"
      />
       <Form/>
    </div>
  )
}

export default Contact